import { render, staticRenderFns } from "./TestuserBuilderList.vue?vue&type=template&id=459af209&scoped=true&"
import script from "./TestuserBuilderList.vue?vue&type=script&lang=js&"
export * from "./TestuserBuilderList.vue?vue&type=script&lang=js&"
import style0 from "./TestuserBuilderList.vue?vue&type=style&index=0&id=459af209&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459af209",
  null
  
)

export default component.exports